import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  & > :last-child {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
`;

export const TutorLabelWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.2px;
`;

export const TeacherNameWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;
